import Alert from "../../../../components/Alert/Alert"
import Button from "../../../../components/Button/Button"
import FolderIcon from "../../../../media/FolderIcon"
import { AddToGroupAlertProps } from "./AddToGroupAlert.types"
import PlusIcon from "../../../../media/PlusIcon"
import "./AddToGroupAlert.css"

const AddToGroupAlert = (props: AddToGroupAlertProps) => {

  const {
    show,
    parentGroups,
    onHide,
    onMove,
    groups,
    selectedGroup,
    onSelectGroup,
    onLoadGroups
  } = props

  const onClickParentGroup = (index: number) => {
    if (parentGroups.length === 0) { 
      onLoadGroups(undefined)
      return
    }
    
    const parentGroup = parentGroups[index]
    onLoadGroups(parentGroup)
  }

  return (
    <Alert showAlert={show} onClose={onHide}>
      <div className="add-to-group-container">
        <div>
          <div className="add-to-group-header">
            <h2>Move</h2>
            <div className="close-add-to-group-header" onClick={() => onHide()}>
              <PlusIcon />
            </div>
          </div>

          <div className="add-to-group-parent-breadcrumbs-container">
            <p onClick={() => onClickParentGroup(-1)}>/</p>
            {parentGroups.map((parentGroup, i) => (
              <p key={parentGroup.id} onClick={() => onClickParentGroup(i)}>{parentGroup.name}/</p>
            ))}
          </div>
        </div>

        <div className="groups-to-add-section">
          {groups.map((group, _) => (
            <div 
              className={`add-to-group-item ${selectedGroup?.id === group.id ? "add-to-group-item-selected" : ""}`}
              key={group.id}
              onClick={() => onSelectGroup(group)}
              onDoubleClick={() => onLoadGroups(group)}
            >
              <FolderIcon />
              <p>{group.name}</p>
            </div>
          ))}

          {groups.length === 0 && (
            <div className="no-results-container">
            <p>{`${selectedGroup?.name} contains no groups.`}</p>
          </div>
          )} 
        </div>
        
        <Button
          className="add-to-group-button"
          type="full"
          title="Move"
          onClick={onMove}
        />
      </div>
    </Alert>
  )
}

export default AddToGroupAlert